import { Divider, Paper, Stack, Typography } from '@mui/material';
import { IPaymentsAndDeductions } from 'API/paymentAndDeductions';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { DataItem } from './DataItem';
import { GroupStatus } from './GroupStatus';
import { BENEFITS_GROUP_STATUS } from 'Enum/paymentsDeduction';

interface IPaymentDeduction {
  paymentDeductionItem: IPaymentsAndDeductions;
}

export const PaymentDeduction = ({
  paymentDeductionItem,
}: IPaymentDeduction) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.PaymentsDeductions
  ).paymentDeductionCard;

  const isDesktop = useIsDesktop();

  console.log(paymentDeductionItem.benefitGroupCode);

  return (
    <Paper
      sx={{
        position: 'relative',
        borderRadius: '16px',
        boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
        background: 'white',
        border: '1px solid',
        borderColor: 'primary.shade_100',
        padding: isDesktop ? '54px 24px 32px 24px' : '44px 16px',
        display: 'flex',
        flexFlow: isDesktop ? 'row' : 'column',
        gap: isDesktop ? '48px' : '',
      }}
    >
      <GroupStatus groupStatus={paymentDeductionItem.benefitGroupCode} />
      <Typography variant={'body1'} width='275px'>
        {paymentDeductionItem.part}
      </Typography>
      <Divider
        variant='fullWidth'
        orientation={isDesktop ? 'vertical' : 'horizontal'}
        sx={{
          display: isDesktop ? 'none' : 'block',
          width: isDesktop ? '1px' : '100%',
          height: isDesktop ? '64px' : '1px',
          borderColor: 'primary.shade_100',
          margin: isDesktop ? '0 32px' : '16px 0',
        }}
        aria-hidden='true'
      />
      <Stack
        direction='row'
        gap={isDesktop ? '45px' : '20px'}
        width='fit-content'
        flexWrap='wrap'
        justifyContent={isDesktop ? '' : 'space-between'}
      >
        <DataItem
          title={
            paymentDeductionItem.benefitGroupCode ===
            BENEFITS_GROUP_STATUS.DEDUCTION
              ? dictionary.deductionAmount
              : dictionary.paymentAmount
          }
          paymentAmount={paymentDeductionItem.appMaanakSum || false}
        />
        <DataItem
          title={dictionary.requestNumber}
          requestNumber={paymentDeductionItem.requestNumber}
        />
        <DataItem
          title={dictionary.lastUpdateDate}
          lastUpdateDate={paymentDeductionItem.statusDate}
        />
        <DataItem
          title={dictionary.treatmentMode}
          status={paymentDeductionItem.statusCode}
        />
      </Stack>
    </Paper>
  );
};
